import React from 'react'
import { CustomDiver, HeaderText, OuterDiv, OuterPadding } from './style'

import { Empty } from 'antd'
import Parameters from './parameter.js'

const PreviousRound = ({ scoreDetail }) => {
  return (
    <OuterDiv>
      <HeaderText>Previous rounds (Showing Avg)</HeaderText>
      <CustomDiver />
      <OuterPadding>
        {scoreDetail?.previousRoundDetails?.length > 0 &&
          scoreDetail?.previousRoundDetails?.map((item, index) => (
            <Parameters key={index + 'roundStatus'} item={item} index={index} />
          ))}
        {scoreDetail?.previousRoundDetails?.length === 0 && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </OuterPadding>
    </OuterDiv>
  )
}

export default PreviousRound
